async function getRandomFile(newLanguageCode: string, supabase: any) {
  //get audio path
  let audioPath = `samples/${newLanguageCode}.wav`

  const fileDataSupabase = await supabase
    .from('audio_files')
    .select('*')
    .eq('language_code', newLanguageCode)
    .eq('active', true)
  const fileData = fileDataSupabase.data

  if (fileData.length > 0) {
    const randomFile =
      fileData[Math.floor(Math.random() * fileData.length)].filename
    audioPath = `dev/${randomFile}`
  }
  return audioPath
}

export default getRandomFile
